/* eslint-disable react-hooks/exhaustive-deps */
import "./admin-table.css";
import swal from "sweetalert";
import { BsTrash3Fill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { deleteCity, fetchAllCities } from "../../redux/apiCalls/cityApiCalls";

const CityTable = () => {
  const dispatch = useDispatch();
  const cities = useSelector((state) => state.city.cities);

  useEffect(() => {
    dispatch(fetchAllCities());
  }, []);

  // Delete department Handler
  const deleteCityHandler = (cityId) => {
    swal({
      title: "هل فعلا تريد الحذف ؟",
      text: "لن تستطيع استعادة البيانات ثانية.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteCity(cityId));
      }
    });
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <h1 className="table-title">المدن</h1>
        <table className="table">
          <thead>
            <tr>
              <th>م</th>
              <th>التخصص</th>
              <th>------</th>
            </tr>
          </thead>
          <tbody>
            {cities?.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>
                  <b className="table-username">{item?.cityName} </b>
                </td>
                <td>
                  <div className="table-button-group">
                    <button onClick={() => deleteCityHandler(item?._id)}>
                      <BsTrash3Fill />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CityTable;
